// Material
import { Box } from '@mui/material'
// Common
import { ProfileInfoItem } from '$common/profile-info-item'
// Localization
import { t } from '$i18n'
import { showCopyMenu } from '$comp/modals/menus/copy-menu'
import { showBioSavedInMemorySnackbar } from '$comp/snackbars'

export function WappProfileInfo({ description }: { description: string }) {
  if (!description) return null
  return (
    <Box sx={{ bgcolor: 'white' }}>
      <ProfileInfoItem
        value={description}
        label={t('user.bio')}
        onClick={() =>
          showCopyMenu({
            text: description,
            onDone: showBioSavedInMemorySnackbar,
          })
        }
      />
    </Box>
  )
}
